<template>
  <div class="text-nowrap bg-inky-depths-700 rounded" @mouseleave="handleMouseLeave" @mouseenter="handleMouseEnter">
    <div class="p-4 w-full flex flex-col gap-2">
      <NuxtLink
        v-for="(item, index) in productItems"
        :key="index"
        :to="{ name: item.routeName }"
        class="flex px-4 py-2 border rounded items-center border border-transparent transition-all duration-200 hover:bg-inky-depths-400"
        :class="`hover:${item.borderColor}`">
        <div class="flex-col">
          <p class="font-semibold">{{ item.title }}</p>
          <p class="text-xs font-light text-wave-crest-100">{{ item.description }}</p>
        </div>
      </NuxtLink>
    </div>
    <NuxtLink :to="{ name: 'contact' }" class="group">
      <div class="p-4 items-center justify-center w-full rounded-b transition-colors bg-inky-depths-900 hover:bg-inky-depths-400">
        <p class="font-semibold">Sales</p>
        <p class="text-xs font-light text-wave-crest-100">Contact our sales team</p>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import type { ProductItem } from '~/types'
const { showProductDropdown } = useShowProductDropdown()

defineProps<{
  productItems: ProductItem[]
}>()

let mouseLeaveTimeout: any = null

const handleMouseLeave = () => {
  mouseLeaveTimeout = setTimeout(() => {
    showProductDropdown.value = false
  }, 1000)
}

const handleMouseEnter = () => {
  clearTimeout(mouseLeaveTimeout)
}
</script>
